import { realityId } from "@/utils/reality-id";
import api from "../api";
import { UserPoints } from "./types/points.types";

export const getUserPoints = async (): Promise<UserPoints | undefined> => {
  const res = await api.get(`/realities/${realityId}/points/me`);
  return res.data;
};
